import { makeVar } from '@apollo/client';

export const userGroupNameVar = makeVar('');
